import { useMutation, useQuery } from "react-query";

import { Type_User } from "src/types/user";

import { createUser, deleteUser, getAllUsers, updateUser } from "./service";

export const useGetUsers = (token: string) => {
    return useQuery({
        queryKey: ["users", token],
        queryFn: () => getAllUsers(token),
        select: (data) => {
            if (!data?.success || !data?.data) {
                throw new Error("Wrong format data: useGetUsers");
            }
            return data.data;
        },
        onError: (err: any) => {
            return err;
        },
    });
};

export const mutationCreateUser = (token: string) => {
    return useMutation({
        mutationFn: (body: Omit<Type_User, "id">) => createUser(body, token),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationCreateUser");
            }
        },
        onError: (err: any) => {
            console.debug("ERROR mutationCreateUser", err);
            return err;
        },
    });
};

export const mutationDeleteUser = (token: string) => {
    return useMutation({
        mutationFn: (id: number) => deleteUser(id, token),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationDeleteUser");
            }
        },
        onError: (err: any) => {
            console.debug("ERROR mutationDeleteUser", err);
            return err;
        },
    });
};

export const mutationUpdateUser = (token: string) => {
    return useMutation({
        mutationFn: async ({
            userId,
            body,
        }: {
            userId: number;
            body: Partial<Type_User>;
        }) => updateUser(userId, body, token),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationUpdateUser");
            }
        },
        onError: (err: any) => {
            console.debug("ERROR mutationUpdateUser", err);
            return err;
        },
    });
};
